import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntry } from '../settings-entry';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/file-backups.svg';
import { h } from 'vue';
import FormToggle from '@frontend/components/FormToggle';

export function SaveBackups() {
    return SettingsEntry(
        'Save backups on/off',

        'Save a backup file when loading a model.',

        img(icon, 'Save backups on/off'),

        h(FormToggle, {
            value: app.settings.save_backups,
            'onUpdate:value': x => app.settings.save_backups = x,
        }),
    );
}
